<template>
  <div class="logout">
    <md-toolbar class="md-primary nav-style first-nav">
      <img src="../assets/logo.png" class="logo-navbar" />
    </md-toolbar>
    <div class="md-title second-navbar">COMUNICAZIONE SICURA</div>
    <md-card class="home-card">
      <md-card-header>
        <h3 class="title-style">Comunicazione Sicura</h3>
        <div class="md-subhead">
          Disconnessione avvenuta con successo. Arrivederci!
        </div>
      </md-card-header>
    </md-card>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";

export default {
  name: "logout",
  data() {
    return { show: false };
  },
  methods: {}
};
</script>

<style scoped="scoped">
/* "scoped" attribute limit the CSS to this component only */
.login {
  margin-top: 40px;
}

input {
  margin: 10px 0;
  width: 20%;
  padding: 15px;
}

button {
  margin-top: 20px;
  width: 10%;
  cursor: pointer;
}

p {
  margin-top: 40px;
  font-size: 13px;
}

p a {
  text-decoration: underline;
  cursor: pointer;
}

.md-card {
  width: 60%;
  margin: 4px;
  display: inline-block;
  vertical-align: center;
}

@media only screen and (max-width: 600px) {
  .md-card {
    width: 80%;
  }
}

.first-nav {
  background-color: #ffffff !important;
}
.logo {
  margin-top: 60px;
  width: 33%;
  height: 10%;
}

.title-style {
  color: #027953;
}

.logo-navbar {
  height: 40px;
}

.md-card {
  width: 60%;
  margin: 4px;
  display: inline-block;
  vertical-align: center;
}

.logo_navbar {
  text-align: center;
  height: 40px;
  padding: 3px;
}

.title-style {
  color: #027953;
  font-size: 20px;
}

.logo {
  margin-top: 60px;
  width: 10%;
  height: 10%;
}

.text-style {
  color: #027953;
  font-size: 15px;
  text-align: center;
  padding-top: 1%;
}

.home-button {
  width: 487px;
}

.md-card {
  width: 60%;
  margin: 4px;
  display: inline-block;
  vertical-align: center;
}

.nav-style {
  height: 50px;
}

.second-navbar {
  background-color: #027953;
  font-size: 26px;
  font-weight: bold;
  color: #ffffff;
  padding: 1.3%;
}

.text-card {
  text-align: right;
  color: grey;
}

.md-card {
  width: 60%;
  margin: 4px;
  display: inline-block;
  vertical-align: center;
}

.act-opt {
  margin-top: 30px;
}

.simple-text {
  color: black;
  font-size: 17px;
}

.button-text {
  padding-top: 6%;
  padding-left: 1%;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Logout.vue